import intelliJetNetService, { QueryBuilder } from '../intellijetnet'
import { Transaction } from '../../types/intellijetnet'
import { executeQuery, executeQueryFirst } from './utils'

export class TransactionsService {
  private static readonly TABLE_NAME = 'transactions'

  /**
   * Get base query builder for transactions
   */
  static query(): QueryBuilder {
    return intelliJetNetService.from(this.TABLE_NAME)
  }

  /**
   * Get transaction by ID
   */
  static async getById(transId: number): Promise<Transaction | null> {
    return executeQueryFirst<Transaction>(
      this.query().eq('trans_id', transId)
    )
  }

  /**
   * Get transactions by model ID
   */
  static async getByModelId(modelId: number): Promise<Transaction[]> {
    return executeQuery<Transaction>(
      this.query()
        .eq('model_id', modelId)
        .order('trans_date', false)
    )
  }

  /**
   * Get transactions by aircraft ID
   */
  static async getByAircraftId(aircraftId: number): Promise<Transaction[]> {
    return executeQuery<Transaction>(
      this.query()
        .eq('aircraft_id', aircraftId)
        .order('trans_date', false)
    )
  }

  /**
   * Get transactions within a date range
   */
  static async getByDateRange(startDate: string, endDate: string): Promise<Transaction[]> {
    return executeQuery<Transaction>(
      this.query()
        .gte('trans_date', startDate)
        .lte('trans_date', endDate)
        .order('trans_date', false)
    )
  }

  /**
   * Get transactions with combined filters
   */
  static async getFiltered(filters: {
    modelId?: number
    aircraftId?: number
    startDate?: string
    endDate?: string
    transactionTypes?: string[]
    limit?: number
  }): Promise<Transaction[]> {
    let query = this.query()

    if (filters.modelId) {
      query = query.eq('model_id', filters.modelId)
    }
    
    if (filters.aircraftId) {
      query = query.eq('aircraft_id', filters.aircraftId)
    }
    
    if (filters.startDate) {
      query = query.gte('trans_date', filters.startDate)
    }
    
    if (filters.endDate) {
      query = query.lte('trans_date', filters.endDate)
    }

    if (filters.transactionTypes && filters.transactionTypes.length > 0) {
      query = query.in('trans_type', filters.transactionTypes)
    }

    query = query.order('trans_date', false)
    
    if (filters.limit) {
      query = query.limit(filters.limit)
    }

    return executeQuery<Transaction>(query)
  }
}

export default TransactionsService